import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@Components/Button';
import Modal from '@Components/Modal';

import ConfirmationMessageModalProps from './ConfirmationMessageModal.types';

const ConfirmationMessageModal: FunctionComponent<ConfirmationMessageModalProps> =
  (props: ConfirmationMessageModalProps): JSX.Element => {
    const { t } = useTranslation();
    /** Props */
    const {
      message,
      isModalOpen,
      headerText,
      confirmButtonText,
      cancelButtonText,
      cancelButtonVariant,
      setIsModalOpen,
      onClick,
      onClose,
    } = props;

    /** Handle Modal State */
    const handleModalClose = () => {
      setIsModalOpen(false);

      if (onClose) {
        onClose();
      }
    };

    return (
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        headerText={
          headerText || t('common.confirmationModal.Confirmation needed')
        }
      >
        <Box position="relative">
          <Box sx={{ p: 2.4 }}>{message}</Box>
          <Box
            sx={{
              borderTop: '0.1rem solid #A3ABB2',
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2.4 }}>
            <Button
              variant={cancelButtonVariant || 'text'}
              color="secondary"
              onClick={handleModalClose}
              sx={{ mr: 1.6 }}
            >
              {cancelButtonText || t('common.confirmationModal.CANCEL')}
            </Button>
            {onClick && (
              <Button type="submit" onClick={onClick}>
                {confirmButtonText || t('common.confirmationModal.CONFIRM')}
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    );
  };

export default ConfirmationMessageModal;
